import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { ImageGroup, Image } from 'react-fullscreen-image';
import "react-vertical-timeline-component/style.min.css";
import './VerticalTimeline.scss'
import WebsiteSVG from "../../assets/icons/Website";
import ReactIcon from "../../assets/icons/WorkProjects/React.png";
import JavaIcon from "../../assets/icons/WorkProjects/Java.png";
import SprinBootIcon from "../../assets/icons/WorkProjects/SpringBoot.png";
import NodejsIcon from "../../assets/icons/WorkProjects/Nodejs.png";
import Cordova from "../../assets/icons/WorkProjects/Cordova.png";
import FigmaIcon from '../../assets/icons/WorkProjects/Figma.png'
import TailwindIcon from '../../assets/icons/WorkProjects/Tailwind.png'
import ScssLogo from '../../assets/icons/WorkProjects/Scss.png'
import Makarandalogo from "../../assets/images/WorkPorjects/MakarandaLogo.png";
import MakarandaMain from "../../assets/images/WorkPorjects/MakarandalkMain.png";
import MakarandaProfileView from "../../assets/images/WorkPorjects/MakarandalkProfileView.png";
import MakarandaTimeline from "../../assets/images/WorkPorjects/MakaradalkTimeline Page.png";
import NestJs from "../../assets/icons/WorkProjects/NestJs.png";
import MongoDB from "../../assets/icons/WorkProjects/MongoDB.png";
import MySQL from "../../assets/icons/WorkProjects/MySQL.png";

function VerticalTimelineComponent() {

  const images = [
    MakarandaMain,
    MakarandaProfileView,
    MakarandaTimeline
  ]

  return (
    <div>
      <VerticalTimeline className='timelinewrapper' >
        <VerticalTimelineElement
          className=" vertical-timeline-element--work text-gray-700"
          contentStyle={{ background: "rgb(255, 255, 255)", color: "#1e1e1e" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(255, 255, 255)" }}
          date="2022 - present"
          iconStyle={{ background: "rgb(196, 152, 119)", color: "#fff" }}
          icon={<WebsiteSVG />}
        >
          <h3 className="vertical-timeline-element-title text-amber-700">Makaranda.lk</h3>
          <h4 className="vertical-timeline-element-subtitle text-gray-500">Wedding and function organizing application</h4>
          <div className="m-2 flex flex-row overflow-x-auto">
            <img className="w-32 mr-5" src={MakarandaMain} alt='reactpic'></img>
            <img className="w-32 mr-5" src={MakarandaProfileView} alt='reactpic'></img>
            <img className="w-32 mr-5" src={MakarandaTimeline} alt='reactpic'></img>
          </div>
          <div className="grid grid-cols-4 md:grid-cols-6 gap-3 align-middle items-center mt-2 pt-2 border-gray-200 border-t-2">
            <img className="w-10 mr-5" src={ReactIcon} alt='reactpic'></img>
            <img className="w-8 mr-5" src={NestJs} alt='javapic'></img>
            <img className="w-8 h-6 mr-5" src={TailwindIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={ScssLogo} alt='javapic'></img>
            <img className="w-8 mr-5" src={FigmaIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={MongoDB} alt='javapic'></img>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work text-gray-700"
          contentStyle={{ background: "rgb(255, 255, 255)", color: "#1e1e1e" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(255, 255, 255)" }}
          date="2022"
          iconStyle={{ background: "rgb(196, 152, 119)", color: "#fff" }}
          icon={<WebsiteSVG />}
        //   icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title text-amber-700">National Development Information System</h3>
          <h4 className="vertical-timeline-element-subtitle text-gray-500">Project Management System for Ministry of
          Finance, Sri Lanka</h4>
          <div className="flex flex-row justify-start align-middle items-center mt-2 pt-2 border-gray-200 border-t-2">
            <img className="w-10 mr-5" src={ReactIcon} alt='reactpic'></img>
            <img className="w-8 h-6 mr-5" src={TailwindIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={ScssLogo} alt='javapic'></img>
            <img className="w-8 mr-5" src={FigmaIcon} alt='javapic'></img>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(255, 255, 255)", color: "#1e1e1e" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(255, 255, 255)" }}
          date="2022"
          iconStyle={{ background: "rgb(196, 152, 119)", color: "#fff" }}
          icon={<WebsiteSVG />}
        //   icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title text-amber-700">ExeLearn for ASEAN.org</h3>
          <h4 className="vertical-timeline-element-subtitle text-gray-500">Learning Managment System for Association of Southeast Asian Nations </h4>
          <div className="grid grid-cols-4 gap-4 align-middle items-center mt-2 pt-2 border-gray-200 border-t-2">
            <img className="w-10 mr-5" src={ReactIcon} alt='reactpic'></img>
            <img className="w-8 h-6 mr-5" src={TailwindIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={ScssLogo} alt='javapic'></img>
            <img className="w-8 mr-5" src={FigmaIcon} alt='javapic'></img>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(255, 255, 255)", color: "#1e1e1e" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(255, 255, 255)" }}
          date="2021"
          iconStyle={{ background: "rgb(196, 152, 119)", color: "#fff" }}
          icon={<WebsiteSVG />}
        //   icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title text-amber-700">Avengers Café</h3>
          <h4 className="vertical-timeline-element-subtitle text-gray-500">Cross platform mobile application</h4>
          <div className="grid grid-cols-4 gap-4 align-middle items-center mt-2 pt-2 border-gray-200 border-t-2">
            <img className="w-10 mr-5" src={ReactIcon} alt='reactpic'></img>
            <img className="w-8 h-6 mr-5" src={TailwindIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={ScssLogo} alt='javapic'></img>
            <img className="w-8 mr-5" src={FigmaIcon} alt='javapic'></img>
            <img className="w-8 mr-5" src={Cordova} alt='javapic'></img>
            <img className="w-8 mr-5" src={MySQL} alt='javapic'></img>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          iconStyle={{ background: "rgb(196, 152, 119)", color: "#fff" }}
        //   icon={<StarIcon />}
        />
      </VerticalTimeline>
    </div>
  );
}

export default VerticalTimelineComponent
